let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("bRo6x")).then(() => parcelRequire('5YJ1A'));